/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Next_UpInputs */

const en_us2_workout_next_up = /** @type {(inputs: Workout_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up next`)
};

const pt_br2_workout_next_up = /** @type {(inputs: Workout_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A seguir`)
};

const es_419_workout_next_up = /** @type {(inputs: Workout_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A continuación`)
};

const pt_pt2_workout_next_up = /** @type {(inputs: Workout_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A seguir`)
};

const fr_fr2_workout_next_up = /** @type {(inputs: Workout_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensuite`)
};

const de_de2_workout_next_up = /** @type {(inputs: Workout_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Nächstes`)
};

const it_it2_workout_next_up = /** @type {(inputs: Workout_Next_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A seguire`)
};

/**
* | output |
* | --- |
* | "Up next" |
*
* @param {Workout_Next_UpInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_next_up = /** @type {((inputs?: Workout_Next_UpInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Next_UpInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_next_up(inputs)
	if (locale === "es-419") return es_419_workout_next_up(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_next_up(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_next_up(inputs)
	if (locale === "de-DE") return de_de2_workout_next_up(inputs)
	if (locale === "it-IT") return it_it2_workout_next_up(inputs)
	return en_us2_workout_next_up(inputs)
});
export { workout_next_up as "workout.next_up" }